import React from 'react';
import { Typography } from 'src/components/PulseUI';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faUsersSlash } from '@fortawesome/pro-solid-svg-icons';

const InvalidSearchCriteria = () => {
  return (
    <div className="w-full h-[25rem] flex flex-col items-center justify-center gap-2">
      <Icon icon={faUsersSlash} size="3x" color="#9FA6AD" />
      <Typography
        variant="body1"
        align="center"
        className="text-[#636B74]"
      >
        No providers found for these search criteria at this location.
      </Typography>
      <Typography
        variant="body1"
        align="center"
        bold
        className="text-[#636B74]"
      >
        Select different criteria to see results.
      </Typography>
    </div>
  );
};

export default InvalidSearchCriteria;
